import "./bannersCompany.css";

import React, { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";

import Pagination from "../../components/Table/Pagination/Pagination";
import LoadingCircular from "../../components/LoadingCircular/LoadingCircular";
import ErrorComponent from "../../components/ErrorComponent/ErrorComponent";
import BannerPanelEditBox from "../../components/EditBox/BannerPanelEditBox";
import { AuthContextValue } from "../../context/AuthContext";
import useFetchPost from "../../hooks/UseFetchPost";
import { Modal } from "antd";
import { CrudContextValue } from "../../context/CrudContext";
import BannerAddForm from "../../components/BannerAddForm/BannerAddForm";
import { GetContextValue } from "../../context/GetContext";
import useFetch from "../../hooks/UseFetch";

// Format date to a more readable format
const formatReadableDate = (date) => {
  return new Date(date).toLocaleDateString("tr-TR", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

function BannersCompany({ t }) {
  const { loginUserCompanyId, token } = AuthContextValue();
  const { createMethod } = CrudContextValue();
  const { notificationRender } = GetContextValue();

  const [loading, setLoading] = useState(false);

  const [addModalVisible, setAddModalVisible] = useState(false);

  const [bannerFilter, setBannerFilter] = useState("");
  const [bannerPage, setBannerPage] = useState(1);
  const [bannerRowsPerPage, setBannerRowsPerPage] = useState(10);

  // "" = "Hepsi"
  // 1 = "Onay Bekleyen"
  // 2 = "Aktif"
  // 3 = "Pasif"
  const {
    setUseFetchRender: setBannersMyUseFetchRender,
    useFetchRender: bannersMyUseFetchRender,
    error: bannersError,
    loading: bannersLoading,
    data: banners,
    total: bannersTotal,
  } = useFetchPost(
    `${process.env.REACT_APP_GET_MY_BANNER_LIST_URL}?CompanyId=${loginUserCompanyId}&Status=${bannerFilter}&Page=${bannerPage}&PageSize=${bannerRowsPerPage}`,
    null,
    token
  );

  useEffect(() => {
    setBannersMyUseFetchRender(!bannersMyUseFetchRender);
  }, [notificationRender]);

  const { total: allBannersTotal } = useFetch(
    `${process.env.REACT_APP_GET_BANNER_LIST_URL}?Page=${1}&PageSize=${1}`,
    token
  );

  const handleOpenAddBannerModal = () => {
    setAddModalVisible(true);
  };
  const handleCloseAddBannerModal = () => {
    setAddModalVisible(false);
  };

  // YENİ REKLAM EKLEME İŞLEMİ
  const addBanner = async (addBannerData) => {
    console.log("addBannerData : ", addBannerData);
    setLoading(true);

    await createMethod(
      process.env.REACT_APP_POST_ADD_BANNER_URL,
      JSON.stringify(addBannerData),
      token
    );

    setLoading(false);

    handleCloseAddBannerModal();

    setBannersMyUseFetchRender(!bannersMyUseFetchRender);
  };

  return (
    <div className="banner-panel-container">
      <div className="banner-panel-edit-box">
        <BannerPanelEditBox
          tableFilter={bannerFilter}
          setTableFilter={setBannerFilter}
          useFetchRender={bannersMyUseFetchRender}
          setUseFetchRender={setBannersMyUseFetchRender}
          handleOpenAddBannerModal={handleOpenAddBannerModal}
        />
      </div>
      <div className="banner-panel-main">
        {bannersError ? (
          <ErrorComponent error={bannersError} />
        ) : bannersLoading ? (
          <LoadingCircular />
        ) : banners && banners.length > 0 ? (
          banners.map((banner, index) => {
            return (
              <div key={index} className="banner-card">
                <div className="image-box">
                  <img src={banner.image} alt=" banner-resim" />
                </div>
                <div className="detail-box">
                  <span
                    className={`banner-status ${
                      Number(banner.status) === 1
                        ? "banner-status-orange"
                        : Number(banner.status) === 2
                        ? "banner-status-green"
                        : "banner-status-red"
                    }`}
                  >
                    {Number(banner.status) === 1
                      ? t("banner_status_waiting")
                      : Number(banner.status) === 2
                      ? t("banner_status_active")
                      : t("banner_status_passive")}
                  </span>
                  <h4>
                    {t("banner_company_name")} : {banner.companyName}
                  </h4>
                  {/* <p>
                    {t("banner_index")} : {banner.index}{" "}
                  </p>
                  <p>
                    {t("banner_duration")} : {banner.displayTime} (
                    {t("banner_duration_second")})
                  </p> */}
                  <p>
                    {t("banner_banner_size")} :{" "}
                    {Number(banner.advertSize) === 1
                      ? t("banner_small")
                      : Number(banner.advertSize) === 2
                      ? t("banner_medium")
                      : Number(banner.advertSize) === 3
                      ? t("banner_big")
                      : ""}{" "}
                  </p>
                  <p>
                    {t("banner_start_date")}:
                    <small> {formatReadableDate(banner.startDate)}</small>
                  </p>
                  <p>
                    {t("banner_end_date")}:
                    <small> {formatReadableDate(banner.finishDate)}</small>
                  </p>
                </div>
              </div>
            );
          })
        ) : (
          <div className="table-null-text">{t("message_no_banner")}</div>
        )}

        {loading && <LoadingCircular />}
      </div>

      <div className="banner-panel-pagination">
        <Pagination
          page={bannerPage}
          setPage={setBannerPage}
          rowsPerPage={bannerRowsPerPage}
          setRowsPerPage={setBannerRowsPerPage}
          total={bannersTotal}
        />
      </div>

      <Modal
        style={{ top: 20 }}
        open={addModalVisible}
        onCancel={handleCloseAddBannerModal}
        footer={null}
      >
        <BannerAddForm
          onCancel={handleCloseAddBannerModal}
          onSubmit={addBanner}
          allBannersTotal={allBannersTotal}
        />
      </Modal>
    </div>
  );
}

export default withNamespaces()(BannersCompany);
